const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		// preventSortOfField: {},
		buttonContext: 'coupon',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'ttgshop_coupons',
		rowActionsProperties: {
			colWidth: '80px'
		},
		rowActions: {}
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'couponID',
				direction: 'asc'
			}]
		}
	},

	methods: {

		dataDealer: function(){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_ttgShop_coupons_controller', function(controller){
					self.model.controller = controller
				});
			}

			if(self.model.controller && !self.config.usage){
				self.config.usage = self.model.controller.config.usage || '';
			}

			if(self.config.usage === 'selection' && !self.model.isInPicker){
				self.model.selectedRowIDs = utils.simpleCopy(self.getResourceRegisterContent('selectedRowIDs') || []);
				self.model.blackListedProductIDs = utils.simpleCopy(self.getResourceRegisterContent('blackListedProductIDs') || []);
			}
		},

		sanitizeEntity: function(refEntity){
			var self = this;
			if(self.config.usage === 'selection' && self.config.isSelectionSource){
				refEntity.selected = utils.indexOf(self.model.selectedRowIDs, refEntity.attributes[refEntity.primaryKey || 'id']) > -1;
			}
		},

		onResourceSanitized: function(){
			if(this.config.isSelectionTarget){
				// correct order of selected entities
				var entityList = this.model.entityList;
				var orderedEntityList = {};
				var orderedEntityListByIndex = [];
				var entityKey, rowIndex, rowID;
				for(rowIndex in this.model.selectedRowIDs || []){
					rowID = this.model.selectedRowIDs[rowIndex];
					entityKey = `entityID_${rowID}`;
					if(entityList[entityKey]){
						entityList[entityKey].index = rowIndex;
						orderedEntityList[entityKey] = entityList[entityKey];
						orderedEntityListByIndex[rowIndex] = entityList[entityKey];
					}
				}

				this.model.entityList = orderedEntityList;
				this.model.entityListByIndex = orderedEntityListByIndex;
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(rowID, rowData, buttonMode){
			return this.performAndStoreAction(
				'showInsert_coupon_inEffect',
				this.prepareAction('showInsert_coupon', undefined, {
					componentDefinition: utils.simpleCopy((this.model.controller || {}).resourceData || {})
				}),
				true
			);
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				if(this.config.usage === 'selection'){
					if(this.config.isSelectionSource && this.model.controller){
						this.model.controller.toggleRowSelection(rowID, rowData);
					}
				} else {
					return getComponent('ttgShopController').showEdit('coupon', rowID);
				}
			}
		},

		delete: function(rowID, rowData, buttonMode){
			if(this.config.usage === 'selection' && this.config.isSelectionTarget){
				if(this.model.isInPicker){
					this.toggleRowSelection(rowID, rowData);
				} else if(this.model.controller){
					this.model.controller.toggleRowSelection(rowID, rowData);
				}
			}
		},

		selectionChanged: function(){
			if(this.model.isInPicker){
				this.triggerClosest('onChildChanged', {
					value: this.getSelectedRowIDs()
				});
			}
		},
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
							if(modalContentComponent && modalContentComponent.hasClass('templates_ttgShop_coupons_propertiesForm')){
								await modalContentComponent.submit()
                                await options.decisionComponent.hide()
                                await this.refreshData()
							}
							break
					}
					break

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break
					}
					break

				default:
					// TODO: ERROR;
					break
			}
		},

		toggleRowSelection: function($element, options){
			this.toggleRowSelection(options.rowID, options.rowData);
		}
	},

	handlers: [{
		name: 'onSubmitDone',
		componentClass: 'templates_ttgShop_coupons_propertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			this.refreshData();
		}
	}]
}
